var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnConductorIos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 187.35,
    height: 44.889,
    viewBox: "0 0 187.35 44.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-2",
    width: 31.943,
    height: 31.89,
    x: 16.229,
    y: 5.611
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187.35,
    height: 44.889,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-2"
  })))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillRule: "evenodd",
    d: "M8 0h171.34995766c4.4153202 0 8 3.5846798 8 8v28.88888889c0 4.4153202-3.5846798 8-8 8H8c-4.4153202 0-8-3.5846798-8-8V8c0-4.4153202 3.5846798-8 8-8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fontSize: 0,
    style: {
      whiteSpace: "pre"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 58.934,
    y: 30.678,
    fill: "rgb(255,255,255)",
    fontFamily: "Montserrat SemiBold",
    fontSize: 20,
    fontWeight: 600,
    style: {
      whiteSpace: "pre",
      textTransform: "none"
    }
  }, "Conductor")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-2"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.943,
    height: 31.89,
    x: 16.229,
    y: 5.611,
    fill: "none",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M45.54974741 28.99074074c-.28102493.56111111-.4683749 1.21574074-.74939983 1.77685185-.8430748 1.87037037-2.06084953 3.5537037-3.46597421 5.14351852-.65572486.65462963-1.40512469 1.21574074-2.34187447 1.40277778-.74939984.18703704-1.49879967.09351852-2.2481995-.09351852l-1.68614962-.56111111c-1.68614961-.65462963-3.37229923-.56111111-4.96477387.09351852-.65572486.28055555-1.3114497.46759259-2.06084954.65462963-1.03042477.18703703-1.96717455 0-2.81024936-.65462963-.74939983-.56111111-1.40512469-1.21574074-1.96717456-1.9638889-1.59247464-1.96388888-2.81024936-4.1148148-3.5596492-6.54629629-.65572485-1.96388889-.93674978-3.92777778-.8430748-5.98518518.09367498-2.15092593.65572485-4.11481482 2.06084953-5.79814815 1.40512468-1.68333333 3.0912743-2.71203704 5.24579882-2.9925926 1.03042476-.09351851 1.96717455 0 2.90392434.37407408.74939983.28055556 1.49879966.56111111 2.34187447.74814815.18734996.09351852.4683749.09351852.65572485.18703704.28102494.09351851.65572485 0 .93674979-.09351852.8430748-.28055556 1.68614962-.56111111 2.43554945-.84166667.93674979-.28055555 1.87349958-.56111111 2.90392434-.56111111 1.7798246.09351852 3.46597422.56111111 4.8710989 1.68333333.56204988.4675926 1.03042477.93518519 1.40512469 1.4962963-2.43554945 1.4962963-3.74699916 3.64722222-3.5596492 6.5462963.37469991 2.80555555 1.96717455 4.67592592 4.49639898 5.98518518z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M38.80514894 5.79814815V7.1074074c-.18734996 2.0574074-1.3114497 3.5537037-2.81024937 4.86296296-.74939983.56111111-1.49879966 1.0287037-2.43554945 1.21574074-.18734995 0-.4683749.09351852-.65572485.09351852h-.65572485c-.09367498-.4675926-.09367498-.93518519 0-1.30925926.4683749-2.525 1.87349958-4.39537037 4.12169907-5.5175926.74939983-.37407407 1.49879966-.5611111 2.34187447-.65462962h.09367498z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnConductorIos);
export default __webpack_public_path__ + "static/media/btn-conductor-ios.4ef9d92db956efb292aff46ab1a16997.svg";
export { ForwardRef as ReactComponent };